module.exports = __webpack_public_path__ + "audio/32fc22b2ceef21006a7f31e18e44f1f3.mp3";